import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    total: {
        id: "homework.total",
    },
    name: {
        id: "join.name",
    },
    legendTotalPlayed: {
        id: "homework.totalPlayed",
    },
    legendTotalFailed: {
        id: "homework.totalFailed",
    },
    legendFirstSuccess: {
        id: "homework.firstSuccess",
    },
    dateOfCompletion: {
        id: "homework.dateOfComplition",
    },
    gaveUp: {
        id: "homework.gaveUp",
    },
});

export default messages;
